/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CreateStateDto,
  StateResponse,
  UpdateStateDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AssetStates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags assetStates
   * @name Create
   * @request POST:/assetStates
   * @secure
   */
  create = (data: CreateStateDto, params: RequestParams = {}) =>
    this.request<StateResponse, any>({
      path: `/assetStates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags assetStates
   * @name FindAll
   * @request GET:/assetStates
   * @secure
   */
  findAll = (params: RequestParams = {}) =>
    this.request<StateResponse[], any>({
      path: `/assetStates`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags assetStates
   * @name FindOne
   * @request GET:/assetStates/{id}
   * @secure
   */
  findOne = (id: string, params: RequestParams = {}) =>
    this.request<StateResponse, any>({
      path: `/assetStates/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags assetStates
   * @name Update
   * @request PATCH:/assetStates/{id}
   * @secure
   */
  update = (id: string, data: UpdateStateDto, params: RequestParams = {}) =>
    this.request<StateResponse, any>({
      path: `/assetStates/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags assetStates
   * @name Remove
   * @request DELETE:/assetStates/{id}
   * @secure
   */
  remove = (id: string, params: RequestParams = {}) =>
    this.request<StateResponse, any>({
      path: `/assetStates/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
}
